"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// let Billing;

var Billing_Form = void 0;

Billing_Form = require("./billing_form").default;

var Billing = function Billing() {
    _classCallCheck(this, Billing);

    (0, _jquery2.default)(document).ready(function () {
        return new Billing_Form((0, _jquery2.default)("#stripe-form"), "subscribe");
    });
    (0, _jquery2.default)(".show-optional-billing").on("click", function (e) {
        e.preventDefault();
        (0, _jquery2.default)(this).parent().addClass("hidden");
        (0, _jquery2.default)("#receipt-info").focus();
        return (0, _jquery2.default)(".optional-billing").addClass("expand-to-visible");
    });
    (0, _jquery2.default)(".hide-optional-billing").on("click", function (e) {
        e.preventDefault();
        (0, _jquery2.default)(".show-optional-billing").parent().removeClass("hidden");
        return (0, _jquery2.default)(".optional-billing").removeClass("expand-to-visible");
    });
};

exports.default = Billing;